var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryHighPriorityPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "29px",
    viewBox: "0 0 22 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "path-1",
    cx: 11,
    cy: 23,
    rx: 5,
    ry: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-60.0%",
    y: "-300.0%",
    width: "220.0%",
    height: "700.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "#F5BE45",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    opacity: 0.517833891,
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,0.288675135 L20.0262794,5.21132487 C20.3356805,5.38995766 20.5262794,5.72008468 20.5262794,6.07735027 L20.5262794,15.9226497 C20.5262794,16.2799153 20.3356805,16.6100423 20.0262794,16.7886751 L11.5,21.7113249 C11.1905989,21.8899577 10.8094011,21.8899577 10.5,21.7113249 L1.97372056,16.7886751 C1.66431948,16.6100423 1.47372056,16.2799153 1.47372056,15.9226497 L1.47372056,6.07735027 C1.47372056,5.72008468 1.66431948,5.38995766 1.97372056,5.21132487 L10.5,0.288675135 C10.8094011,0.11004234 11.1905989,0.11004234 11.5,0.288675135 Z",
    id: "Polygon-Copy-14",
    stroke: "#F5BE45",
    fill: "#22CDC8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(6.700000, 5.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon",
    fill: "#F5BE45",
    points: "4.33012702 0.5 8.66025404 3 8.66025404 8 4.33012702 10.5 0 8 0 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    opacity: 0.119512649,
    points: "4.33012702 5.8622449 0 3 0 8 4.33012702 10.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#000000",
    opacity: 0.119512649,
    transform: "translate(6.495191, 6.750000) scale(-1, 1) translate(-6.495191, -6.750000) ",
    points: "8.66025498 5.8622449 4.33012796 3 4.33012796 8 8.66025498 10.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryHighPriorityPickup);
export default __webpack_public_path__ + "static/media/delivery-high-priority-pickup.f777b474a7c97160212c77315029bdb3.svg";
export { ForwardRef as ReactComponent };